<template>
  <!-- 课程分类抽屉 -->
  <el-drawer
    title="全部分类"
    :visible.sync="drawer"
    direction="rtl"
    :before-close="handleClose"
    :custom-class="isH5 ? 'h5-classify-drawer' : 'classify-drawer'"
    :size="isH5 ? '' : 800"
    :show-close="false"
  >
    <img
      v-if="isH5"
      @click="handleClose"
      class="drawer-close"
      src="../../../assets/images/home/h5-close-icon.png"
      alt=""
    />
    <img
      v-else
      @click="handleClose"
      class="drawer-close"
      src="../../../assets/images/home/drawer-close.png"
      alt=""
    />
    <div class="body-wrap">
      <!-- 我的分类 -->
      <div class="my-classify">
        <p class="title">
          我的分类
          <button
            @click="submitCategory"
            class="save-btn"
            v-preventReClick
            :disabled="submiting"
          >
            完成
          </button>
        </p>
        <draggable
          v-if="myClassify.length"
          :options="{
            group: 'title',
            animation: 300,
            ghostClass: 'sortable-ghost',
          }"
          :no-transition-on-drag="true"
          :list="myClassify"
        >
          <transition-group class="my-classify-list" type="transition">
            <div
              class="my-classify-item"
              v-for="(item, index) in myClassify"
              :key="item.id"
            >
              <i
                v-if="isH5"
                @click="deleteMyclassify(index, item)"
                class="el-icon-close close"
              />
              <img
                v-else
                @click="deleteMyclassify(index, item)"
                class="close"
                src="../../../assets/images/home/close-icon.png"
                alt=""
              />
              {{ item.category_name }}
            </div>
          </transition-group>
        </draggable>
      </div>
      <!-- 更多分类 -->
      <div class="more-classify">
        <p class="title">
          更多分类<span class="tips">点击添加至我的分类</span>
        </p>
        <div v-if="categoryList.length" class="classify-list">
          <div
            v-for="(category, pIndex) in categoryList"
            :key="category.id"
            class="category-item"
          >
            <p class="first-level-title">{{ category.category_name }}</p>
            <ul
              class="subclass-list"
              v-if="category.child && category.child.length"
            >
              <li
                @click="addClassify(item, pIndex, subIndex)"
                v-for="(item, subIndex) in category.child"
                :key="item.id"
              >
                <div v-if="item.isAdded !== 1" class="subclass-item">
                  {{ item.category_name }}
                </div>
              </li>
            </ul>
            <p v-show="category.isAllAdded" class="empty-tips">
              已全部添加至 “我的分类”
            </p>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { isH5 } from "@saas/components/src";
import {
  getCategoryList,
  getCategoryTree,
  saveCategory,
} from "@saas/server-api/src/category";
import draggable from "vuedraggable";
export default {
  data: function () {
    return {
      isH5: isH5(),
      drawer: false,
      myClassify: [],
      categoryList: [],
      initData: [], //初始化数据
      submiting: false,
    };
  },
  methods: {
    deleteMyclassify(index, item) {
      this.myClassify.splice(index, 1);
      let pIndex = this.categoryList.findIndex((category) => {
        return category.id === item.pid;
      });
      if (pIndex !== -1 && this.categoryList[pIndex]?.child?.length) {
        let subIndex = this.categoryList[pIndex].child.findIndex((child) => {
          return child.id === item.id;
        });
        if (subIndex !== -1) {
          this.categoryList[pIndex].child[subIndex].isAdded = 0;
          if (this.categoryList[pIndex].isAllAdded) {
            this.$set(this.categoryList[pIndex], "isAllAdded", false);
          }
        }
      }
    },
    submitCategory() {
      if (this.submiting) return;
      this.submiting = true;
      let category_id = [];
      this.myClassify.forEach((item) => {
        category_id.push(item.id);
      });
      if (!category_id.length) {
        this.$message.warning("最少需要添加 1 个分类");
        this.submiting = false;
        return false;
      }
      let params = {
        category_id,
      };
      saveCategory(params)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("保存成功");
            this.$emit("saveCategory");
            this.inintDrawerData();
          } else {
            this.$message.error(res.message);
            this.submiting = false;
          }
        })
        .catch(() => {
          this.submiting = false;
        });
    },
    addClassify(item, pIndex, subIndex) {
      if (!(this.myClassify.length < 20)) {
        this.$message.warning("最多添加20个分类");
        return false;
      }
      this.myClassify.push({
        id: item.id,
        category_name: item.category_name,
        pid: this.categoryList[pIndex].id,
      });
      this.$set(this.categoryList[pIndex].child[subIndex], "isAdded", 1);
      this.categoryList[pIndex].isAllAdded = this.categoryList[
        pIndex
      ].child.every((item) => {
        return item.isAdded === 1;
      });
    },
    handleClose(type) {
      if (type !== "save") {
        // 校验我的分类是否改变
        let arr = [];
        this.myClassify.forEach((item) => {
          arr.push(item.id);
        });
        if (arr.join(",") !== this.initData.join(",")) {
          this.$confirm(
            "我的分类已经编辑过，离开将无法保存这些改动，是否保存？",
            "提示",
            {
              confirmButtonText: "保存",
              cancelButtonText: "离开",
              dangerouslyUseHTMLString: true,
              type: "warning",
              closeOnClickModal: false,
            }
          )
            .then(() => {
              this.submitCategory();
            })
            .catch(() => {
              this.inintDrawerData();
            });
        } else {
          this.inintDrawerData();
        }
      } else {
        this.inintDrawerData();
      }
    },
    inintDrawerData() {
      this.drawer = false;
      this.myClassify = [];
      this.categoryList = [];
      this.initData = [];
      setTimeout(() => {
        this.submiting = false;
      }, 100);
    },
    openDrawer() {
      this.drawer = true;
      this.apiGetCategoryList();
    },
    apiGetCategoryList() {
      getCategoryList().then((res) => {
        if (res.code === 1) {
          this.myClassify = res.data || [];
          this.apiGetCategoryTree();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    apiGetCategoryTree() {
      getCategoryTree().then((res) => {
        if (res.code === 1) {
          this.categoryList = res.data || [];
          if (res.data?.length && this.myClassify?.length) {
            this.myClassify.forEach((item) => {
              this.initData.push(item.id);
              let index = this.categoryList.findIndex((category) => {
                return category.id === item.pid;
              });
              if (index !== -1 && this.categoryList[index]?.child?.length) {
                let subIndex = this.categoryList[index].child.findIndex(
                  (child) => {
                    return child.id === item.id;
                  }
                );
                if (subIndex !== -1) {
                  this.categoryList[index].child[subIndex].isAdded = 1;
                }
                this.categoryList[index].isAllAdded = this.categoryList[
                  index
                ].child.every((item) => {
                  return item.isAdded === 1;
                });
              }
            });
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  computed: {},
  components: {
    draggable,
  },
};
</script>

<style lang="scss" scoped>
::v-deep .classify-drawer .el-drawer__header {
  padding: 30px 30px 0 0;
  font-weight: 500;
  font-size: 20px;
  color: $saas-text-color;
  line-height: 28px;
  text-align: center;
  margin-bottom: 26px;
}
::v-deep .classify-drawer .el-drawer__body {
  margin-right: 5px;
}
::v-deep .classify-drawer .el-drawer__body::-webkit-scrollbar {
  width: 7px;
}
::v-deep .classify-drawer .el-drawer__body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.classify-drawer {
  position: relative;
  .drawer-close {
    -webkit-app-region: none;
    cursor: pointer;
    position: absolute;
    width: 16px;
    height: 16px;
    right: 30px;
    top: 30px;
  }
  .body-wrap {
    padding-left: 40px;
    padding-bottom: 40px;
    // height: 1200px;
  }
  .my-classify {
    .title {
      padding-top: 3px;
      position: relative;
      padding-right: 38px;
      display: flex;
      justify-content: space-between;
      font-weight: 500;
      font-size: 16px;
      color: $saas-text-color;
      line-height: 22px;
      margin-bottom: 13px;
      .save-btn {
        position: absolute;
        right: 38px;
        top: 0;
        width: 45px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #ffffff;
        line-height: 16px;
        background: url("../../../assets/images/home/drawer-save-bg.png")
          no-repeat center;
        background-size: 100% 100%;
      }
    }
    .my-classify-list {
      margin-bottom: 24px;
      display: flex;
      flex-wrap: wrap;
    }
    .my-classify-item {
      position: relative;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #effefb;
      border-radius: 8px;
      min-width: 130px;
      padding: 0 6px;
      height: 40px;
      margin-right: 15px;
      margin-bottom: 16px;
      font-size: 14px;
      color: #333;
      .close {
        position: absolute;
        right: -3px;
        top: -6px;
        cursor: pointer;
        width: 16px;
        height: 16px;
      }
    }
  }
  .more-classify {
    .title {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      font-weight: 500;
      font-size: 16px;
      color: $saas-text-color;
      line-height: 22px;
      .tips {
        font-weight: 400;
        font-size: 14px;
        color: $plain-text-color;
        line-height: 20px;
        margin-left: 12px;
      }
    }
  }
  .category-item {
    margin-top: 12px;
    &:first-child {
      margin-top: 0px;
    }
    .first-level-title {
      position: relative;
      font-weight: 500;
      font-size: 14px;
      color: $saas-text-color;
      line-height: 20px;
      margin-bottom: 12px;
      padding-left: 8px;

      &::after {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        display: block;
        content: "";
        width: 2px;
        height: 10px;
        background: linear-gradient(
          132deg,
          $linear-gradient-begin 0%,
          $linear-gradient-end 100%
        );
        border-radius: 1px;
      }
    }
  }
  .subclass-list {
    display: flex;
    flex-wrap: wrap;
    .subclass-item {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      background: #f5f5f5;
      border-radius: 8px;
      min-width: 130px;
      padding: 0 6px;
      margin-right: 18px;
      margin-bottom: 18px;
      font-size: 14px;
      color: $plain-text-color;
    }
  }
  .empty-tips {
    font-size: 12px;
    color: #888988;
    line-height: 17px;
    padding-bottom: 18px;
  }
}
.sortable-ghost {
  opacity: 0;
}

// h5适配
::v-deep .h5-classify-drawer {
  width: 100%;
  .el-drawer__header {
    display: none;
  }
  .el-drawer__body {
    margin-right: 5px;
  }
  .el-drawer__body::-webkit-scrollbar {
    width: 7px;
  }
  .classify-drawer .el-drawer__body::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }
}
.h5-classify-drawer {
  position: relative;
  .drawer-close {
    width: 0.51rem;
    height: 0.51rem;
    margin: 0.32rem;
  }
  .body-wrap {
    padding: 0 0 0.4rem 0.32rem;
  }
  .my-classify {
    .title {
      display: flex;
      justify-content: space-between;
      font-weight: 500;
      font-size: 0.48rem;
      color: #0d1400;
      line-height: 0.67rem;
      margin-bottom: 0.32rem;
      .save-btn {
        width: 1.17rem;
        height: 0.59rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 0.32rem;
        color: #ffffff;
        line-height: 1;
        background: url("../../../assets/images/home/drawer-save-bg.png")
          no-repeat center;
        background-size: 100% 100%;
      }
    }
    .my-classify-list {
      margin-bottom: 0.54rem;
      display: flex;
      flex-wrap: wrap;
    }
    .my-classify-item {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #effefb;
      border-radius: 0.21rem;
      min-width: 2.97rem;
      padding: 0 0.2rem;
      height: 1.07rem;
      margin-right: 0.21rem;
      margin-bottom: 0.2rem;
      font-size: 0.32rem;
      color: #0d1400;
      .close {
        position: absolute;
        right: 0.06rem;
        top: 0.06rem;
        padding: 0.1rem;
        font-size: 0.2rem;
        color: #888988;
      }
      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
  .more-classify {
    .title {
      display: flex;
      align-items: center;
      margin-bottom: 0.43rem;
      font-size: 0.48rem;
      color: #0d1400;
      line-height: 0.67rem;
      .tips {
        font-weight: 400;
        font-size: 0.32rem;
        color: #888988;
        line-height: 0.44rem;
        margin-left: 0.16rem;
      }
    }
  }
  .category-item {
    margin-top: 0.43rem;
    .first-level-title {
      font-weight: 500;
      font-size: 0.37rem;
      color: #0d1400;
      line-height: 0.53rem;
      margin-bottom: 0.32rem;
    }
  }
  .subclass-list {
    display: flex;
    flex-wrap: wrap;
    .subclass-item {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 1.07rem;
      background: #f5f5f5;
      border-radius: 0.21rem;
      min-width: 2.97rem;
      padding: 0 0.2rem;
      margin-right: 0.2rem;
      margin-bottom: 0.2rem;
      font-size: 0.32rem;
      color: #515350;
    }
    li:nth-child(3n) .subclass-item {
      margin-right: 0;
    }
  }
  .empty-tips {
    font-weight: 400;
    font-size: 0.32rem;
    color: #888988;
    line-height: 0.44rem;
    padding-bottom: 0.21rem;
  }
}
</style>
